import { Component, h, Prop } from '@stencil/core';

import { BaseChart } from '../../models';

@Component({
  tag: 'uui-chart-empty-message',
  styleUrl: 'uui-chart-empty-message.scss',
  shadow: false,
  scoped: true
})
export class UuiChartEmptyMessage {
  @Prop() hasSlot: boolean;

  @Prop() model: BaseChart;

  render() {
    return this.hasSlot ? (
      <slot name="empty-message"></slot>
    ) : (
      <p>{this.model.emptySeriesMessage}</p>
    );
  }
}
